<div class="reclaim-modal">

  <!-- ── Header ─────────────────────────────────────────────────── -->
  <div class="reclaim-header">
    <h2 class="reclaim-title">Reclaim Engine</h2>
    <button class="reclaim-close-btn" (click)="activeModal.dismiss('Cross click')">
      <img src="assets/images/virtusa-icons/close.svg" alt="close" width="30" height="30" />
    </button>
  </div>

  <!-- ── Body ───────────────────────────────────────────────────── -->
  <div class="reclaim-body">

    <!-- Selected chips -->
    <div class="reclaim-section">
      <p class="reclaim-section-label">Selected Engines ({{ selectedItems.length }})</p>
      <div class="chips-wrap">
        <span *ngIf="selectedItems.length === 0" class="no-selection-hint">
          Select engines from the table below
        </span>
        <div *ngFor="let item of selectedItems" class="chip">
          <span class="chip-label">{{ item.name }}</span>
          <button class="chip-remove" (click)="removeChip(item)">
            <img src="assets/images/virtusa-icons/close-dark.svg" alt="remove" width="10" height="10" />
          </button>
        </div>
      </div>
    </div>

    <!-- Available engines table -->
    <div class="reclaim-section">
      <p class="reclaim-section-label">Available Engines ({{ allItems.length }})</p>
      <div class="reclaim-table-wrap">
        <table class="reclaim-table">
          <thead>
            <tr>
              <th class="col-name">
                <label class="th-checkbox-label">
                  <input
                    type="checkbox"
                    class="reclaim-checkbox"
                    [checked]="isAllSelected"
                    (change)="toggleSelectAll($event)"
                  />
                  Engine Name
                </label>
              </th>
              <th class="col-type">Type</th>
              <th class="col-status">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of allItems"
              class="reclaim-row"
              [class.reclaim-row--selected]="item.selected"
              (click)="toggleSelect(item)"
              (keydown.space)="toggleSelect(item)"
            >
              <td class="col-name">
                <label class="td-checkbox-label" (click)="$event.stopPropagation()">
                  <input
                    type="checkbox"
                    class="reclaim-checkbox"
                    [(ngModel)]="item.selected"
                    (change)="syncSelected()"
                  />
                  {{ item.name }}
                </label>
              </td>
              <td class="col-type">
                <span class="type-cell">
                  <img
                    [src]="getTypeIcon(item.typeLabel || item.type)"
                    alt="{{ item.typeLabel || item.type }}"
                    class="type-icon"
                    width="16"
                    height="16"
                  />
                  {{ item.typeLabel || item.type }}
                </span>
              </td>
              <td class="col-status">
                <span class="status-pill" [ngClass]="getStatusClass(item.statusLabel)">
                  <span class="status-dot"></span>
                  {{ item.statusLabel }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- ── Footer ─────────────────────────────────────────────────── -->
  <div class="reclaim-footer">
    <button class="btn-reclaim-cancel" (click)="activeModal.dismiss('Cross click')">Cancel</button>
    <button
      class="btn-reclaim-primary"
      (click)="reclaim()"
      [disabled]="selectedItems.length === 0"
    >
      Reclaim
    </button>
  </div>

</div>
